<div class="modal-header align-items-center d-flex justify-content-between">
  <h4 class="modal-title text-white mb-0">Time Sheet Entry</h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <ng-container>
    <app-project-dropdown
      [selectedProject]="project"
      (projectSelected)="onProjectSelected($event)"
      [disabled]="timeSheetEntry.approved"
    ></app-project-dropdown>
    <div class="form-group">
      <label for="category" class="visually-hidden">Category</label>
      <div class="input-with-icon position-relative">
        <i class="bi bi-tag"></i>
        <input
          type="text"
          class="form-control"
          id="category"
          name="category"
          [(ngModel)]="timeSheetEntry.category"
          (input)="onCategoryInput($event)"
          (focus)="onCategoryFocus()"
          (blur)="onCategoryBlur()"
          placeholder="* Category"
          autocomplete="off"
          [disabled]="timeSheetEntry.approved"
          required
          />
        @if (isCategoryDropdownOpen && filteredCategories.length > 0 && !timeSheetEntry.approved) {
          <ul
            class="dropdown-menu dropdown-menu-end w-100 show category-autocomplete"
            [attr.data-bs-popper]="'static'"
            >
            @for (category of filteredCategories; track category) {
              <li>
                <button
                  class="dropdown-item"
                  type="button"
                  (click)="selectCategory(category)"
                  >
                  {{ category }}
                </button>
              </li>
            }
          </ul>
        }
      </div>
    </div>
    <div class="form-group">
      <div class="hours-input-container">
        <div class="hours-range-wrapper">
          <input
            [(ngModel)]="timeSheetEntry.hours"
            type="range"
            class="form-range hours-range"
            min="0"
            max="8"
            step="0.25"
            id="hoursRange"
            #hoursInput
            [disabled]="timeSheetEntry.approved"

            required
            />

          <div class="hours-tooltip visible" #hoursTooltip>
            {{ formatHours(timeSheetEntry.hours) }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="description" class="visually-hidden">Description</label>
      <div class="input-with-icon">
        <i class="bi bi-file-earmark-text"></i>
        <textarea
          class="form-control"
          id="description"
          name="description"
          [(ngModel)]="timeSheetEntry.description"
          placeholder="* Description"
          rows="5"
          required
          [disabled]="timeSheetEntry.approved"
        ></textarea>
      </div>
    </div>

    @if (errorMessage) {
      <div class="alert alert-danger mb-3">
        {{ errorMessage }}
      </div>
    }
  </ng-container>
</div>

<div class="modal-footer d-flex justify-content-between">
  <div>
    @if(timeSheetEntry.id && !timeSheetEntry.approved){
      <button
        type="button"
        class="btn btn-outline-danger"
        (click)="onDeleteTimeSheetEntry()"
        >
        Delete
      </button>
    }
  </div>
  <div>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="close()"
      >
      Close
    </button>
    @if(!timeSheetEntry.approved){
      <button
        type="button"
        class="btn btn-primary ms-3"
        (click)="onSaveTimeSheetEntry()"
        >
        Save
      </button>
    }
  </div>
</div>
